export default "__VITE_ASSET___IVSFVL0__"